import React from "react";
import { FaEnvelope, FaPhoneAlt, FaHardHat, FaMapMarkerAlt } from "react-icons/fa";
import "./Contact.css";

// Put the file at: src/assets/mng-owner.jpg
import heroImg from "../../assets/mng-owner.jpg";

const ContactPage = () => {
  const heroStyle = {
    backgroundImage: `linear-gradient(135deg, rgba(0,82,154,.85) 0%, rgba(0,180,216,.85) 100%), url(${heroImg})`,
  };

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-page-hero" style={heroStyle}>
        <div className="contact-page-hero-content contact-page-container">
          <div className="contact-page-hero-text">
            <h1>Build Your Vision With Us</h1>
            <p>Get in touch with our construction experts today for a free consultation</p>
            <div className="contact-page-hero-stats" />
          </div>
        </div>
        <div className="contact-page-scroll-indicator">
          <div className="scroll-arrow" />
        </div>
      </section>

      {/* Main */}
      <main className="contact-page-main contact-page-container">
        {/* Get In Touch */}
        <section className="contact-page-info-section centered-contact-info">
          <div className="contact-page-section-header">
            <div>
              <FaHardHat className="contact-page-section-icon" />
            </div>
            <h2>Get In Touch</h2>
            <p>We're here to help with your construction needs. Reach out to us through any of these channels.</p>
          </div>

          <div className="contact-page-details centered-contact-details">
            {/* Phone */}
            <article className="contact-page-card">
              <div className="contact-page-icon-wrapper">
                <div className="contact-page-icon">
                  <FaPhoneAlt />
                </div>
              </div>
              <div className="contact-page-text">
                <h3>Phone Number</h3>
                <p>360-625-5045</p>
                <a href="tel:360-625-5045" className="contact-page-link">
                  Call now <span>→</span>
                </a>
              </div>
            </article>

            {/* Email */}
            <article className="contact-page-card">
              <div className="contact-page-icon-wrapper">
                <div className="contact-page-icon">
                  <FaEnvelope />
                </div>
              </div>
              <div className="contact-page-text">
                <h3>Email Address</h3>
                <p>info@mngcinc.com</p>
                <a href="mailto:info@mngcinc.com" className="contact-page-link">
                  Send email <span>→</span>
                </a>
              </div>
            </article>

            {/* Location */}
            <article className="contact-page-card">
              <div className="contact-page-icon-wrapper">
                <div className="contact-page-icon">
                  <FaMapMarkerAlt />
                </div>
              </div>
              <div className="contact-page-text">
                <h3>Service Area</h3>
                <p>Washington State and Northern Idaho</p>
                <div className="contact-page-link location-link" aria-disabled="true">
                  Serving the entire region <span>→</span>
                </div>
              </div>
            </article>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ContactPage;
